'use client';

import { Icon } from '@iconify-icon/react';
import Image from 'next/image';
import Link from 'next/link';

import PageLink from '@/utils/PageLink';

const FinalCTA: React.FC = () => {
  return (
    <section aria-label="Final CTA" className="bg-white py-16 sm:py-20" id="book-demo">
      <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="overflow-hidden rounded-[44px] bg-[#edf2f8]">
          <div className="grid items-center gap-8 sm:gap-10 md:grid-cols-2">
            <div className="flex flex-col justify-center px-6 py-10 text-center sm:px-10 sm:py-12 md:px-12 md:text-left">
              <h2 className="mx-auto max-w-2xl text-3xl font-bold text-gray-900 sm:text-4xl md:mx-0">
                Ready to Activate Your Enterprise Intelligence?
              </h2>
              <p className="mx-auto mt-5 max-w-xl text-lg text-gray-600 md:mx-0">
                See how our platform can transform your proprietary knowledge into your most
                valuable asset. Schedule a personalized demo with one of our experts to explore your
                specific use case.
              </p>
              <div className="mt-10 flex flex-col items-center gap-4 sm:flex-row md:items-start">
                <Link
                  href={PageLink.demo}
                  className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-primary-600 px-6 py-3 text-sm font-medium text-white hover:bg-primary-700 sm:w-auto">
                  Book a demo
                  <Icon icon="tabler:arrow-right" className="text-lg" />
                </Link>
                <Link
                  href={PageLink.login}
                  className="inline-flex w-full items-center justify-center rounded-full border border-primary-600/30 bg-transparent px-6 py-3 text-sm font-medium text-primary-600 hover:bg-primary-50 sm:w-auto">
                  Start 14-Day Trial
                </Link>
              </div>
            </div>

            <div className="relative h-60 w-full sm:h-80 md:h-[420px] lg:h-[460px]">
              <Image
                src="/images/cta-image.png"
                alt=""
                fill
                className="object-contain object-center md:object-right"
                priority
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
